<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-input ttRememberId="w_jobschedules.searchtext" ttLabel="searchtext" ttFocus="true" [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
            <tt-button-goto ttText="jobschedules_new" ttGoto="jobschedule" [ttGotoParms]="{ jobschedule_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>

        <tt-list [ttData]="itemsListSchedules" [ttFilter]="setting.searchtext"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <tt-input ttRememberId="w_jobschedules.searchtext" ttLabel="searchtext" ttFocus="true" [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
            </tt-card>

            <tt-card class="col-xs-12 col-md-2 p-5">
                <tt-button-goto ttText="jobschedules_new" ttGoto="jobschedule" [ttGotoParms]="{ jobschedule_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
            </tt-card>
        </div>

        <tt-list class="col-xs-12 col-md-4 p-5" [ttData]="itemsListSchedules" [ttFilter]="setting.searchtext"></tt-list>
    </div>
</tt-page>
